import { type TemplateResult } from '@design.estate/dees-element';
import type { DeesChartGauge } from './component.js';

export const renderChartGauge = (component: DeesChartGauge): TemplateResult => {
  return component.renderChartFrame();
};
